<template>
    <html>
      <body class="" style="background: #FFF">
        <HeaderMobil :localNavigation="true" v-on:go-to-back="changeGoToBack" />
        <MenuLateralMobile/>
        <div class="h-screen grid grid-cols-6 grid-rows-12 grid-flow-col">
           <MenuLateral/>
            <div class="bg-container col-span-6">
                <Questions :category="category" :lastPage="counterGoBack"/>
            </div>
        </div>
      </body>
    </html>
</template>

<script>
import { onBeforeMount, ref } from 'vue';
import { useRouter } from 'vue-router';
import MenuPrincipal from "@/components/Cuenta/MenuPrincipal.vue";
import Questions from "@/components/Cuenta/Quote/QuoteAdditionalInsuanceQuestions.vue";
import HeaderMobil from "@/components/Cuenta/HeaderMobil.vue";
import MenuLateralMobile from '@/components/MenuLateralMobile.vue';;
import MenuLateral from '@/components/LateralMenu.vue';;
import Footer from '@/components/Footer.vue';

export default {
    setup(){
        const router = useRouter();
        const category = ref('');
        let counterGoBack = ref(0);

        onBeforeMount(()=>{
            category.value = router.currentRoute.value.params.category;
        });

        const changeGoToBack = () => {
            counterGoBack.value = counterGoBack.value+1;
            console.log("goToBack", counterGoBack.value)
        }

        return {
            category,
            changeGoToBack,
            counterGoBack
        }
    },
    components:{
        MenuPrincipal,
        HeaderMobil,
        MenuLateralMobile,
        MenuLateral,
        Footer,
        Questions
    }
}
</script>

<style scoped>
.description {
    font-family: 'roboto-regular';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 33px;
    color: #485462;
}
</style>